import mainLogo from '../../images/BelcarFiat/LOGO  MIDIA COOPERADA BRANCA.png';
import squareLogo from '../../images/BelcarFiat/logo_belcarfiat_02.png';
import squareLogoColor from '../../images/BelcarFiat/logo_belcarfiat_color_01.png';
import mainLogoColor from '../../images/BelcarFiat/LOGO-MIDIA-COOPERADA-PRETA_square.png';
import banner01 from '../../images/BelcarFiat/banner_01.jpg';
import banner02 from '../../images/BelcarFiat/banner_02.jpg';
import banner03 from '../../images/BelcarFiat/banner_01.jpg';
import car123 from '../../images/BelcarFiat/123_toro.jpg';
import box123 from '../../images/BelcarFiat/123_belcarfiat.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Belcar Fiat',
    defaultStoreLink: 'belcarfiatpecas.com.br',
    defaultContactEmail: 'supervisorvendasfiat@belcarfiat.com.br',
    whatsappNumber: '62 99871 8302',
    CNPJ: '38.484.211-0001/10',
    CNPJname: 'Belcar Automoveis LTDA',
    CNPJaddress: 'Rod. BR153 - KM 501.15 QUADRA18 LOTE 01/24 B - Alto da Glória, Goiânia/GO - 74.815-780',
    launchDate: '30/04/2025',

    multiContact: {},

    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAISTESTING',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "fiat",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "BELCAR FIAT",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    pixDiscount: 0.05,

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        // {
        //     name: 'Luzes',
        //     img: 'tabLuzes',
        //     products: SliderProducts.Luzes
        // },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: mainLogo,

    banner01: banner01,
    banner02: banner02,
    bannerBrands: '',
    aboutUsBg: banner03,


    car123: car123,
    box123: box123,
    
    paymentImg: mainLogoColor,
    paymentImgMobile: mainLogoColor,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu Fiat. Peças <mark>genuínas</mark> direto das concessionárias <mark>Belcar Fiat</mark>.',

    aboutUs: {
        title: 'Belcar Fiat',
        content: [
            'Como concessionária autorizada FIAT, oferecemos peças genuínas que garantem a máxima qualidade, segurança e desempenho para o seu veículo. Nossos produtos seguem rigorosos padrões de fabricação e são a escolha ideal para manter a originalidade e a durabilidade do seu FIAT. Conte com nossa equipe especializada para fornecer as melhores soluções em peças e acessórios.',
        ],
        link: 'https://www.belcarfiat.com.br/fiat-belcar-br/fale-conosco/entre-em-contato',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Google: 'https://maps.app.goo.gl/MSTj5KDUQvKMHyqc8',
        Instagram: 'https://www.instagram.com/belcarfiat/',
        Facebook: 'https://www.facebook.com/Belcar-FIAT-108705251054273',
        LinkedIn: '',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}